import { PropsWithChildren } from "react";
import useResponsive from "../../../hooks/useResponsive";
import { PropsWithClassName } from "../../../models/props-with-class-name";
import styles from "./ManagementHeader.module.css";
type ManagementHeaderProps = PropsWithChildren<PropsWithClassName<{}>>;

const ManagementHeader = ({ className, children }: ManagementHeaderProps) => {
  const { isTabletPortrait } = useResponsive();
  return (
    <header
      className={`${styles.header} ${className} app-shadow
      ${!isTabletPortrait && "d-flex"} font-md muted-color align-items-center`}
    >
      {children}
    </header>
  );
};

type ManagementHeaderDividerProps = PropsWithClassName<{}>;

export const ManagementHeaderDivider = ({
  className,
}: ManagementHeaderDividerProps) => (
  <div className={`${styles.divider} ${className}`}></div>
);

export default ManagementHeader;
